const BUS_EVENT = "xbyte-access-denied";

export function requestAccessDenied(detail) {
  window.dispatchEvent(new CustomEvent(BUS_EVENT, { detail }));
}

export function subscribeAccessDenied(handler) {
  const h = e => handler?.(e.detail);
  window.addEventListener(BUS_EVENT, h);
  return () => window.removeEventListener(BUS_EVENT, h);
}
